import 'jquery.mmenu/dist/jquery.mmenu.all.js'

jQuery(document).ready(function ($) {
	$('#mobile-menu').mmenu({
		extensions: ['pagedim-black'],
		wrappers: ['wordpress'],
	})

	$('#mobile-menu').on('open.mm', function () {
		$('#toggle').addClass('active')
	})

	var api = $('#mobile-menu').data('mmenu')

	$('#toggle').click(function () {
		api.open()
	})

	$('.search-icon').on('click', function () {
		api.close()
	})
})
